import * as React from 'react';
import { useState } from 'react';
import { CurrentUserDto } from '../../../../../../types/UserDtos';
import Button from '../../../../components/Button';
import { isHr } from '../../../../services/User';
import { GetADemoModal } from './GetADemoModal';

type Props = {
    user: CurrentUserDto;
};

const GetADemoButton: React.FC<Props> = ({ user }) => {
    const [isOpen, setisOpen] = useState(false);

    const { company } = user;

    if (company.creator === user.id && isHr(user) && !company.payment.paidFrom && !company.payment.freeUntil) {
        return (
            <>
                <GetADemoModal isOpen={isOpen} setisOpen={setisOpen} userServer={user.company.server} />
                <div className="app-header-button-content app-header-button-consultation">
                    <Button
                        kind="PRIMARY"
                        isSmall
                        onClick={() => setisOpen(true)}
                        eventTracking={{ category: 'navigation header', action: 'request demo' }}
                    >
                        {user.company.server !== 'prod-eu' ? <span>Book a Consultation</span> : <span>Get a Demo</span>}
                    </Button>
                </div>
            </>
        );
    }
    return null;
};

export default GetADemoButton;
